import { useMemo } from 'react'
import { useNavigate } from 'react-router-dom'
import {
  Badge,
  BPSBadge,
  FallbackCompanyIcon,
  FallbackGroupIcon,
  GroupStatusBadge,
  LoadingPage,
  useIsMobile,
  UserRole,
} from '@valiant/ui-shared'
import { AdminModeContent } from '../components/AdminModeContent'
import { SwapModeContent } from '../components/SwapModeContent'
import { useNavigation } from '../contexts/NavigationContext'
import { CompanyRoleBadge } from '@valiant/ui-shared'
import { MainLayout } from '../components/layout/MainLayout'
import { useAuth } from '../AuthProvider'

export function Dashboard() {
  const navigate = useNavigate()
  const { isMobile } = useIsMobile()
  const { auth } = useAuth()
  const userRole = auth?.role

  // Use navigation context
  const {
    isSwapMode,
    selectedGroup,
    selectedCompany,
    groupsLoading,
    companiesLoading,
    setNotificationsOpen,
  } = useNavigation()

  const headerTitle = useMemo(() => {
    return isSwapMode ? selectedCompany?.company : selectedGroup?.name
  }, [isSwapMode, selectedCompany, selectedGroup])

  const headerImage = useMemo(() => {
    return isSwapMode ? selectedCompany?.imageUrl : selectedGroup?.imageUrl
  }, [isSwapMode, selectedCompany, selectedGroup])

  const badges = useMemo(() => {
    return [
      {
        node: !isSwapMode ? (
          <GroupStatusBadge status={selectedGroup?.status || ''} />
        ) : userRole === UserRole.Trader ? null : (
          <Badge variant="outline" className="text-xs ">
            {selectedCompany?.group}
          </Badge>
        ),
        direction: 'LEFT',
      },
      {
        node: !isSwapMode ? (
          <BPSBadge bps={selectedGroup?.bps ?? 0} tone="group" />
        ) : (
          <CompanyRoleBadge tradeType={selectedCompany?.tradeType || ''} />
        ),
        direction: 'RIGHT',
      },
    ]
  }, [selectedCompany, isSwapMode, selectedGroup, userRole])
  if (groupsLoading && companiesLoading) {
    return <LoadingPage />
  }
  return (
    <MainLayout
      redirectOnSelect={false}
      breadcrumbs={[
        {
          label: headerTitle || '',
          imageUrl: headerImage || undefined,
          fallbackImage: isSwapMode ? <FallbackCompanyIcon /> : <FallbackGroupIcon />,
        },
      ]}
      hideBack={true}
      headerTitle={headerTitle}
      headerImage={headerImage || undefined}
      badges={badges}
    >
      {isSwapMode ? (
        <SwapModeContent />
      ) : (
        <AdminModeContent
          onOpenNotifications={() => {
            if (isMobile) {
              navigate('/mobile/notifications')
            } else {
              setNotificationsOpen(true)
            }
          }}
        />
      )}
    </MainLayout>
  )
}
